import { render, staticRenderFns } from "./supplyServiceCapabilityInfo.vue?vue&type=template&id=22d34d0c&scoped=true"
import script from "./supplyServiceCapabilityInfo.vue?vue&type=script&lang=js"
export * from "./supplyServiceCapabilityInfo.vue?vue&type=script&lang=js"
import style0 from "./supplyServiceCapabilityInfo.vue?vue&type=style&index=0&id=22d34d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d34d0c",
  null
  
)

export default component.exports